import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";
import { EContexteMesureLingette } from "./enums/context-lingette";
import { ELifeCycleStatus } from "../enums/life-cycle-status";

export class MeasureLingette {
    @AutoMap()
    Code!: string;
    @AutoMap()
    IsCancelled!: boolean;
    @AutoMap()
    SamplingID!: number;
    @AutoMap()
    SamplingTime?: Temporal.PlainTime;
    @AutoMap()
    Localisation?: string;
    @AutoMap()
    TypeSurface?: string;
    @AutoMap()
    ReferenceLot?: string;
    @AutoMap()
    Temoin?: string;
    @AutoMap()
    VisibilitePoussiere?: boolean;
    @AutoMap()
    SurfacePrelevement: number = 0.1;
    @AutoMap()
    Contexte?: EContexteMesureLingette;
    @AutoMap()
    ApresNettoyage?: boolean;
    @AutoMap()
    Observation?: string;
    @AutoMap()
    ReferenceEtiquette?: string
    @AutoMap()
    Status: ELifeCycleStatus = ELifeCycleStatus.NotCompletedAndNotPositioned;
    @AutoMap()
    Position!: number;
}